import { Form, FormField } from "@babackapp/ui/components/form";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormSaveButton from "@babackapp/react-hook-forms-components/form-save-button";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import useAddDomain from "@babackapp/private-api-client/client/use-add-domain";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

const AddDomainFormSchema = z.object({
  domainName: z.string(),
});

type AddDomainFormValues = z.infer<typeof AddDomainFormSchema>;

type AddDomainFormProps = {
  onSuccess: (values: AddDomainFormValues) => void;
};

export function AddDomainForm({ onSuccess }: AddDomainFormProps) {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: addDomain } = useAddDomain(shop);

  const onSubmit = async ({ domainName }: { domainName: string }) => {
    await addDomain({ domainName });
    onSuccess({ domainName });
    form.reset({ domainName });
  };

  const form = useForm<AddDomainFormValues>({
    resolver: zodResolver(AddDomainFormSchema),
    defaultValues: {
      domainName: "",
    },
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-8"
      >
        <FormField
          control={form.control}
          name="domainName"
          render={({ field }) => (
            <FormInput
              label="Domain"
              description="Insert your domain name here. For example: baback.co"
              {...field}
            />
          )}
        />
        <FormSaveButton />
      </form>
    </Form>
  );
}
